import React from "react";
import {FormattedDate, FormattedMessage, FormattedTime} from "react-intl";
import {REQUESTED_TIME_ASAP, REQUESTED_TIME_PRESENT} from "@/data/entities/order";
import {isToday} from "@/utils/DateUtils";

type WithRequestedTime = {
    requestedTime: string,
};

const getRequestedDate = (order: WithRequestedTime): Date | null => {
    if (order.requestedTime === REQUESTED_TIME_ASAP || order.requestedTime === REQUESTED_TIME_PRESENT)
        return null;

    const date = new Date(order.requestedTime);
    return isNaN(date.getTime()) ? null : date;
};

type Props = {
    order: WithRequestedTime,
    // Shows the date before the time when it's not today (an order in advance)
    withDate?: boolean,
};

const RequestedTime = ({order, withDate = true}: Props) => {
    // The customer already waits in the restaurant
    if (order.requestedTime === REQUESTED_TIME_PRESENT) {
        return <FormattedMessage id={"pos.order.present"}/>;
    }

    const requested = getRequestedDate(order);

    if (requested === null) {
        return <FormattedMessage id={"pos.order.asap"}/>;
    }

    const time = (
        <FormattedTime
            value={requested}
            hour={"2-digit"}
            minute={"2-digit"}
            hourCycle={"h23"}
        />
    );

    if (!withDate || isToday(requested))
        return time;

    return (
        <>
            <FormattedDate value={requested} weekday={"short"} day={"numeric"} month={"short"}/>
            {" "}
            {time}
        </>
    );
};

export default RequestedTime;